import { useLocalStorage } from "@mantine/hooks";

interface Redirector {
  bingoGameId?: string;
  subPlaceId?: string;
  redirectTo: string;
}

export function useSavedRedirector() {
  return useLocalStorage<Redirector | null>({
    key: "redirector",
    getInitialValueInEffect: false,
  });
}
